var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.entityId ? _c('div', {
    attrs: {
      "id": "bio-material-entity-form"
    }
  }, [_c('h2', {
    attrs: {
      "id": "bio-material-type-title",
      "data-test": "inside-vif"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")]), _vm._v(" "), _c('h3', [_vm._v("Are you sure?")]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.removeEntity.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-buttons"
  }, [_c('v-button', {
    staticClass: "destructive",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Remove")]), _vm._v(" "), _c('v-button', {
    staticClass: "primary ghost"
  }, [_c('b-link', {
    attrs: {
      "href": "/"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }